import React, { FC, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Add, ArrowBack } from '@mui/icons-material';
import { Box, Typography, Button } from '@mui/material';

import { PatchesName } from '../../../helpers/types';
import { useGetMe } from '../../../graphql/query/hooks/useGetMe';
import { useGetUsersQuery } from '../../../graphql/query/__generated__/getUsers';
import { AddProjectModal } from './AddProjectModal';
interface Props {
  userId?: string | undefined;
  isMeProject: boolean | undefined;
  getUserId: (event: string) => void;
}

const TitleProject: FC<Props> = ({ getUserId, userId, isMeProject }) => {
  const { me } = useGetMe();
  const { data: dataUsers } = useGetUsersQuery({ variables: { current: false } });
  const [isModalRemove, setIsModalRemove] = useState(false);

  const getUserById = dataUsers?.users?.find(i => i.id === userId);

  const handlerClick = () => {
    if (isMeProject) {
      setIsModalRemove(true);
    } else {
      getUserId(me?.id || '');
    }
  };

  return (
    <Box mb={5} width="100%" display="flex" justifyContent="space-between">
      <Box pl={2} display="flex">
        <Typography fontSize="1.7em" textTransform="none" color="#262626">
          {isMeProject ? 'Мои проекты' : `Проекты: ${getUserById?.name}`}
        </Typography>
      </Box>
      <Box display="flex">
        <Button
          variant="contained"
          startIcon={isMeProject ? <Add /> : <ArrowBack />}
          onClick={handlerClick}
          sx={{
            '&': {
              color: '#fff',
              height: '50px',
              bgcolor: '#5269A3',
              borderRadius: '10px',
            },
          }}
        >
          <Typography color="#e5e5e5" fontSize="14px">
            {isMeProject ? 'Добавить проект' : `Вернуться к своим проектам`}
          </Typography>
        </Button>
      </Box>
      {isModalRemove && (
        <AddProjectModal
          closeModal={() => setIsModalRemove(false)}
          handlerAddProject={handlerClick}
        />
      )}
    </Box>
  );
};

export default TitleProject;
